import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function RulePlus(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="M2,16H10V14H2M18,14V10H16V14H12V16H16V20H18V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z"
            />
        </SvgIcon>
    );
}
function RuleMinus(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="M2,16H10V14H2M12,14V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z"
            />
        </SvgIcon>
    );
}
function DatePlus(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z"
            />
        </SvgIcon>
    );
}
function DateMinus(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M14 17V19H22V17H14Z"
            />
        </SvgIcon>
    );
}

function RuleAdd(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="m12.993 9.0904h-1.9861v2.9792h-2.9792v1.9861h2.9792v2.9792h1.9861v-2.9792h2.9792v-1.9861h-2.9792zm-5.0844-5.571-1.2711-1.5194-4.568 3.8232 1.281 1.5194zm14.022 2.3138-4.568-3.8332-1.281 1.5194 4.568 3.8332zm-9.9305-1.7081c-4.9355 0-8.9374 4.002-8.9374 8.9374 0 4.9355 3.9921 8.9374 8.9374 8.9374 4.9355 0 8.9374-4.002 8.9374-8.9374 0-4.9354-4.002-8.9374-8.9374-8.9374m0 15.889c-3.8431 0-6.9513-3.1083-6.9513-6.9514 0-3.8431 3.1082-6.9513 6.9513-6.9513s6.9513 3.1083 6.9513 6.9513c0 3.8431-3.1082 6.9514-6.9513 6.9514"
            />
        </SvgIcon>
    );
}
function RuleDel(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="m7.0347 12.042v1.9861h9.9305v-1.9861zm0.87391-8.5222-1.2711-1.5194-4.568 3.8232 1.281 1.5194zm14.022 2.3138-4.568-3.8332-1.281 1.5194 4.568 3.8332zm-9.9305-1.7081c-4.9355 0-8.9374 4.002-8.9374 8.9375 0 4.9355 3.9921 8.9374 8.9374 8.9374 4.9355 0 8.9374-4.002 8.9374-8.9374 0-4.9354-4.002-8.9375-8.9374-8.9375m0 15.889c-3.8431 0-6.9513-3.1083-6.9513-6.9514 0-3.8431 3.1082-6.9513 6.9513-6.9513s6.9513 3.1083 6.9513 6.9513c0 3.8431-3.1082 6.9514-6.9513 6.9514"
            />
        </SvgIcon>
    );
}
function DateDel(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="m7.4546 12.909v1.8182h9.0909v-1.8182zm11.818-9.0909h-0.90909v-1.8182h-1.8182v1.8182h-9.0909v-1.8182h-1.8182v1.8182h-0.90908c-1 0-1.8182 0.81817-1.8182 1.8182v14.545c0 1 0.8182 1.8182 1.8182 1.8182h14.545c0.99999 0 1.8182-0.81816 1.8182-1.8182v-14.545c0-1-0.8182-1.8182-1.8182-1.8182m0 16.364h-14.545v-11.818h14.545z"
            />
        </SvgIcon>
    );
}
function DateAdd(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="currentColor"
                d="m12.909 10.207h-1.8182v2.7273h-2.7273v1.8182h2.7273v2.7273h1.8182v-2.7273h2.7273v-1.8182h-2.7273zm6.3636-6.3892h-0.90907v-1.8182h-1.8182v1.8182h-9.0909v-1.8182h-1.8182v1.8182h-0.90908c-0.99999 0-1.8182 0.81817-1.8182 1.8182v14.546c0 0.99998 0.81821 1.8182 1.8182 1.8182h14.545c1 0 1.8182-0.81817 1.8182-1.8182v-14.546c0-0.99998-0.8182-1.8182-1.8182-1.8182m0 16.364h-14.545v-11.818h14.545z"
            />
        </SvgIcon>
    );
}

export { RulePlus, RuleMinus, DatePlus, DateMinus, RuleAdd, RuleDel, DateAdd, DateDel };
